const getFile = (accepts?: string): Promise<File | null> => {
  return new Promise((resolve, reject) => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.style.display = 'none';
    if (accepts) {
      fileInput.accept = accepts;
    }

    const handleEvent = () => {
      const file = fileInput.files?.[0];
      if (!file) {
        reject(new Error('No file selected'));
        return;
      }
      resolve(file);
    };

    fileInput.addEventListener('change', handleEvent);
    fileInput.addEventListener('cancel', () => resolve(null));

    document.body.appendChild(fileInput);
    fileInput.click();
    fileInput.remove();
  });
};

export default getFile;
